/**
 * Navigation / header configuration
 * Centralized configuration for navigation bar behavior (e.g. notification bell polling)
 */

const DEFAULT_PENDING_APPROVALS_POLL_INTERVAL_MS = 600_000; // 10 minutes
const MIN_POLL_INTERVAL_MS = 10_000;   // 10 seconds
const MAX_POLL_INTERVAL_MS = 600_000;  // 10 minutes

function parsePollIntervalMs(): number {
  const raw = import.meta.env.VITE_PENDING_APPROVALS_POLL_INTERVAL_MS;
  if (raw === undefined || raw === '') return DEFAULT_PENDING_APPROVALS_POLL_INTERVAL_MS;
  const n = parseInt(String(raw), 10);
  if (!Number.isFinite(n)) return DEFAULT_PENDING_APPROVALS_POLL_INTERVAL_MS;
  return Math.max(MIN_POLL_INTERVAL_MS, Math.min(MAX_POLL_INTERVAL_MS, n));
}

/**
 * Interval in milliseconds for refetching the pending-approvals summary (notification bell).
 * Only used when SignalR push is not connected; when push is connected, the server pushes updates.
 * Only applies when the user has permission and the tab is visible.
 *
 * Override via environment variable:
 * - VITE_PENDING_APPROVALS_POLL_INTERVAL_MS (default: 600000, clamped to 10000–600000)
 */
export const PENDING_APPROVALS_POLL_INTERVAL_MS = parsePollIntervalMs();
